import {setApplicationError} from "../app/Slice";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import ClientService, {IClientCreateEdit, ICreateClientUser} from "../../api/clientService";
import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import i18n from "../../config/i18n";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {TicketStatus} from "../../component/client-panel/vouchers/vouchers-filter/VouchersFilterHelper";
import TicketService from "../../api/ticketService";
import UserService from "../../api/userService";

export const getClients =
    createAsyncThunk(`${SliceNames.CLIENT}/getClients`,
        async (_, thunkAPI) => {
            try {
                const res = await ClientService.fetchClients()

                return res.data
            } catch (e: any) {
                thunkAPI.dispatch(setApplicationError({isError: true, statusCode: undefined}))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getClient =
    createAsyncThunk(`${SliceNames.CLIENT}/getClient`,
        async (id: string, thunkAPI) => {
            try {
                const res = await ClientService.fetchClientById(id)

                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const createClient =
    createAsyncThunk(`${SliceNames.CLIENT}/createClient`,
        async (req: {
            client: IClientCreateEdit,
            clientUsers: ICreateClientUser[],
            handleCloseDialog: () => void
        }, thunkAPI) => {
            try {
                const res = await ClientService.createClient(req.client)
                for (const clientUser of req.clientUsers) {
                    await ClientService.inviteClientUser(res.data.id, clientUser)
                }
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return {data: res.data, users: req.clientUsers}
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })


export const updateClient =
    createAsyncThunk(`${SliceNames.CLIENT}/updateClient`,
        async (req: {
            clientId: string,
            client: IClientCreateEdit,
            clientUsers: ICreateClientUser[],
            handleCloseDialog: () => void
        }, thunkAPI) => {
            try {
                const res = await ClientService.updateClient(req.clientId, req.client)
                for (const clientUser of req.clientUsers) {
                    await ClientService.inviteClientUser(req.clientId, clientUser)
                }
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return {data: res.data, users: req.clientUsers}
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getClientWishTickets =
    createAsyncThunk(`${SliceNames.CLIENT}/getClientWishTickets`,
        async (req: {
            wishId: string,
            offset: number,
            search_text?: string,
            status?: TicketStatus,
            limit: number,
        }, thunkAPI) => {
            try {
                const {wishId, ...params} = req
                const res = await TicketService.fetchClientWishTickets(wishId, params)

                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const updateVoucherComment =
    createAsyncThunk(`${SliceNames.CLIENT}/updateVoucherComment`,
        async (req: { code: string, comment: string, handleDialogClose: () => void }, thunkAPI) => {
            try {
                const res = await ClientService.updateTicketComment([req.code], req.comment)
                req.handleDialogClose()
                toastSuccess(res.data.detail)

                return {code: req.code, comment: req.comment}
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const disableClientUser =
    createAsyncThunk(`${SliceNames.CLIENT}/disableClientUser`,
        async (req: { userId: string, clientId: string, handleDialogClose: () => void }, thunkAPI) => {
            try {
                await UserService.deleteUser(req.userId)
                req.handleDialogClose()
                toastSuccess(i18n.t('disable_client_user_success'))
                return {userId: req.userId, clientId: req.clientId}
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })